import EventsManager from '../events/EventsManager';
import CustomEvents from '../events/CustomEvents';

class YoutubeManager {
  constructor() {

    // properties
    this.players = [];
    this.isLoadedApi = false;

    //import YOUTUBE API one time ( if there is more than one player present in the DOM)
    const YTApiLink = "https://www.youtube.com/iframe_api";

    //check if Youtube Api is present
    const hasYtAPI = document.querySelectorAll('[src="' + YTApiLink + '"]').length > 0;

    //if YOUTUBE API is not present we load it
    if (!hasYtAPI) {
      const loadApi = new Promise((resolve, reject) => {
        let script = document.createElement("script");
        script.onload = resolve;
        script.onerror = reject;
        script.src = YTApiLink;
        document.getElementsByTagName("head")[0].appendChild(script);
      }).then(() => {
        window.onYouTubeIframeAPIReady = () => {
          //API is ready for the global DOM
          window.YTIsLoaded = true;
          this.isLoadedApi = true;

          EventsManager.broadcast(CustomEvents.youtube.API_LOADED)
        };
      });
    } else {
      EventsManager.broadcast(CustomEvents.youtube.API_LOADED)
    }
  }

  static start() {
    if (!YoutubeManager.instance) {
      YoutubeManager.instance = new YoutubeManager();
    }
  }

  static bind(id, element) {

    const players = YoutubeManager.instance.players;

    // id type check
    if (typeof id !== 'string') {
      console.error('YoutubeManager :: Bind :: Invalid ID', id);
      return;
    }

    // fn type check
    if (typeof element !== 'object') {
      console.error('YoutubeManager :: Bind :: object', element);
      return;
    }

    let pIds = [];

    // use id check
    players.forEach(player => {
      const playerId = player.id;

      if(!pIds.includes(playerId)) {
        pIds.push(playerId);
      }

      if (id === playerId) {
        console.warn('YoutubeManager :: Bind :: ID already used !', id);
        return;
      }
    });
    
    
    // Fixes duplicates in players
    if(!pIds.includes(element.id)) {
      players.push(element);
    }
  }

  static pauseAllPlayersExceptOneIsPlaying(id) {
    const players = YoutubeManager.instance.players;
    const temp = id;

    players.forEach(player => {
      if (player.id != temp) {
        player.stop();

        if (player.hasPoster) {
          player.displayPoster();
        }

        player.isPlaying = false;
      } else {
        player.isPlaying = true;

        if (!player.checkPercentView && player.hasTracking) {
          player.percentViewed()
        }
      }
    });
  }

  static stopAllPlayers() {
    const players = YoutubeManager.instance.players;

    players.forEach(player => {
      player.stop();

      if (player.hasPoster) {
        player.displayPoster();
      }

      player.playerInfos.isPlaying = false;
    });
  }


  static unbind(id) {
    const players = YoutubeManager.instance.players;

    // id type check
    if (typeof id !== 'string') {
      console.error('YoutubeManager :: unBind :: Invalid ID', id);
      return;
    }

    // use id check
    players.forEach((player, i) => {
      const playerId = player.id;
      if (id === playerId) {
        players.splice(i, 1);
      }
    });
  }
}

export default YoutubeManager;
